import { serverUri } from 'utils/config';
import { getAuthorizationHeader } from 'utils/microfrontend/api';

export async function fetchExpenseCompsVersionsFromCompPlex(ids: string[]) {
  const response = await fetch(`${serverUri}/api/compplex/expense-comps-versions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthorizationHeader(),
    },
    body: JSON.stringify({ ids }),
  });

  const data = await response.json();
  return data;
}

export async function fetchExpenseComps(
  filters: any,
  sortField: any,
  sortDirection: any,
  pageSize: any,
  currentPage: any
): Promise<any> {
  const response = await fetch(`${serverUri}/api/compplex/expense-comps`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getAuthorizationHeader() },
    body: JSON.stringify({
      ...filters,
      sortField,
      sortDirection,
      pageSize,
      currentPage,
    }),
  });

  if (!response.ok) {
    throw new Error(`Error fetching expense comps: ${response.statusText}`);
  }
  const data = await response.json();
  const expenseComps = data.comps.map((expenseComp: any) => {
    return { ...expenseComp };
  });

  const totalCount = data.totalCount;
  return {
    totalCount,
    expenseComps,
    availableLocations: data.availableLocations,
    availableStates: data.availableStates,
  };
}
